import { Collapse, Grid } from "@mui/material";
import RenderDateLine from "./renderDateLine";
import React from "react";
import TimeSlot from "./timeSlot";
import FullName from "./fullName";
import LastDay from "./lastDay";
import PhoneNumber from "./phoneNumber";
import Qualification from "./qualification";
import RemainingAppointments from "./remainingAppointments";
import Uploads from "./uploads";
import Email from "./email";
import AppaointmentStatus from "./status";
import ExpandMoreButton from "../../../../components/inputs/expandMoreButton/expandMoreButton";
import IDayliPlanAppointment from "../interface/iDayliPlanAppointment";
import { DayliPlanContext } from "../context/dayliPlanContext";
import IDayliPlan from "../interface/iDayliPlan";
import { ShowFileDialogProps } from "../../../searchParticipant/interfaces/interfaces";

const RenderApoointment = ({
  appointment,
}: {
  appointment: IDayliPlanAppointment;
}): React.JSX.Element => {
  const {
    dayliPlan,
    setDayliPlan,
    setShowFileDialog,
    getTileBackgroundColor,
  }: {
    dayliPlan: IDayliPlan;
    setDayliPlan: (dayliPlan: IDayliPlan) => void;
    setShowFileDialog: (showFileDialog: ShowFileDialogProps) => void;
    getTileBackgroundColor: (appointment: IDayliPlanAppointment) => string;
  } = React.useContext(DayliPlanContext);

  return (
    <React.Fragment>
      {appointment.showDateLine && <RenderDateLine appointment={appointment} />}

      <Grid
        container
        sx={{
          backgroundColor: getTileBackgroundColor(appointment),
          mb: 2,
          px: 2,
          pt: 2,
          borderRadius: 2,
        }}
      >
        <Grid
          item
          xs={12}
          sm={4}
          sx={{
            mb: 2,
          }}
        >
          <TimeSlot appointment={appointment} />
        </Grid>

        <Grid
          item
          xs={12}
          sm={5}
          sx={{
            mb: 2,
          }}
        >
          <FullName appointment={appointment} />
        </Grid>

        <Grid
          item
          xs={12}
          sm={3}
          sx={{
            mb: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: {
              xs: "center",
              sm: "flex-end",
            },
          }}
        >
          <ExpandMoreButton
            onClick={() => {
              appointment.showAllAppointments =
                !appointment.showAllAppointments;

              setDayliPlan({
                ...dayliPlan,
                appointments: [...dayliPlan.appointments],
              });
            }}
            expand={appointment.showAllAppointments}
          />
        </Grid>

        <Collapse
          in={appointment.showAllAppointments}
          timeout="auto"
          unmountOnExit
        >
          <Grid container>
            <PhoneNumber appointment={appointment} />
            <LastDay appointment={appointment} />
            <Email appointment={appointment} />
            <AppaointmentStatus appointment={appointment} />
            <Uploads
              appointment={appointment}
              setShowFileDialog={setShowFileDialog}
            />
            <Qualification appointment={appointment} />
            <RemainingAppointments appointment={appointment} />
          </Grid>
        </Collapse>
      </Grid>
    </React.Fragment>
  );
};

export default RenderApoointment;
